import { useFormikContext, getIn } from "formik";
import { SudoButton } from "src/sudokit/components/SudoButton";

function ApiInputBlockEditor({ optionsPath }) {
  const { values, setFieldValue } = useFormikContext();
  const blockOptions = getIn(values, optionsPath);

  return (
    <div className="flex flex-col gap-2">
      <div>
        {blockOptions.variables.map((variable) => {
          return (
            <div
              className="flex gap-2"
              key={variable.id}
            >
              <input
                className="border-1 border-gray-300 p-0 focus:border-blue-500 focus:outline-none"
                type="text"
                value={variable.name}
                placeholder="Variable name"
                onChange={(e) => {
                  setFieldValue(optionsPath, {
                    ...blockOptions,
                    variables: blockOptions.variables.map((v) => (v.id === variable.id ? { ...v, name: e.target.value } : v)),
                  });
                }}
              />
              <input
                className="border-1 border-gray-300 p-0 focus:border-blue-500 focus:outline-none flex-1"
                type="text"
                value={variable.description}
                placeholder="Variable description"
                onChange={(e) => {
                  setFieldValue(optionsPath, {
                    ...blockOptions,
                    variables: blockOptions.variables.map((v) => (v.id === variable.id ? { ...v, description: e.target.value } : v)),
                  });
                }}
              />
              <SudoButton
                variant="tertiary"
                className="mt-0 p-0"
                onClick={(e) => {
                  e.preventDefault();
                  setFieldValue(optionsPath, {
                    ...blockOptions,
                    variables: blockOptions.variables.filter((v) => v.id !== variable.id),
                  });
                }}
              >
                Remove
              </SudoButton>
            </div>
          );
        })}
      </div>
      <div className="flex gap-2">
        <SudoButton
          variant="tertiary"
          className="mt-0"
          onClick={(e) => {
            e.preventDefault();
            setFieldValue(optionsPath, {
              ...blockOptions,
              variables: [...blockOptions.variables, { id: `var-${blockOptions.variables.length + 1}`, name: "new_variable" }],
            });
          }}
        >
          Add Variable
        </SudoButton>
      </div>
    </div>
  );
}

export default ApiInputBlockEditor;
